import { Product } from '@thisisdevelopment/akzonobel-core';

export const hasColors = (product: Product) =>
  product.colorCollectionColorIds.length > 1;

export const isColorCard = (product: Product) =>
  product.productType === 'Colorcard';

export const isAccessory = (product: Product) =>
  product.productType === 'Accessory';
